import {API_GATEWAY_BASE_URL, getGatewayAuthHeader} from "../gatewayConfig";

export type BracketEntry = {
    driver_id: number;
    drbb_id: number;
    driver_name: string;
    qualifying_position: number;
    best_et?: number;
    best_mph?: number;
};

export type BracketRun = {
    id?: number;
    driver: number;
    driver_name?: string;
    lane?: string;
    reaction_time?: number;
    sixty_foot?: number;
    three_thirty_foot?: number;
    six_sixty_foot?: number;
    six_sixty_foot_mph?: number;
    thousand_foot?: number;
    thousand_foot_mph?: number;
    quarter_mile?: number;
    quarter_mile_mph?: number;
    et?: number;
    mph?: number;
    dial_in?: number;
    placement?: number;
    margin_of_victory?: number;
    disqualification?: string;
};

export type BracketMatchup = {
    matchup_number: number;
    top_seed?: BracketEntry;
    bottom_seed?: BracketEntry;
    winner?: BracketEntry;
    top_run?: BracketRun;
    bottom_run?: BracketRun;
    status: string;
};

export type BracketRound = {
    round: string;
    matchups: BracketMatchup[];
};

export type BracketGatewayResponse = {
    status: string;
    data: {
        event: number;
        category: number;
        qualifiers: number;
        rounds: BracketRound[];
        timestamp: string;
    };
};

export async function fetchBracketByEventName(
    eventName: string,
    category: number
): Promise<BracketGatewayResponse> {
    if (!API_GATEWAY_BASE_URL) {
        throw new Error("API_GATEWAY_BASE_URL is not defined in environment.");
    }

    const url = new URL("/api/v1/bracket", API_GATEWAY_BASE_URL);
    url.searchParams.set("event", eventName);
    url.searchParams.set("category", String(category));

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            ...getGatewayAuthHeader(),
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch bracket: ${response.status} ${response.statusText}`);
    }

    const data = await response.json() as BracketGatewayResponse;

    if (data.status !== "success") {
        throw new Error("Bracket response did not indicate success.");
    }

    return data;
}
